export const Email = {
  required: true,
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  },
};
export const Password = {
  required: true,
  minLength: 8,
  maxLength: 80,
};

export const TrailerNo = {
  required: true
};

export const Code = {
  required: true,
  minLength: 6,
  maxLength: 6,
};

export const FullName = { required: true, maxLength: 80 };
// export const LatitudeValues = { required: true,pattern:{value:'([0-8]?[0-9]\.\d+|90\.0+/i)'}, };
export const Phone = {
  required: true,
  pattern: { value: /^\d{5,15}$/, message: "Invalid phone number" },
};

export const PhoneOptional = {
  required: false,
  pattern: { value: /^\d{5,15}$/, message: "Invalid phone number" },
};
export const PhoneRequired = {
  required: true,
  pattern: { value: /^\d{5,15}$/, message: "Invalid phone number" },
};
export const UaePhone = {
  required: true,
  pattern: { value: /^[0-9]{9}$/, message: "Mobile number must be exactly 9 digits" },
};
export const LatitudeValidator = {
  required: true,
  pattern: {
    value: /^([-+]?(?:[0-8]?\d(?:\.\d+)?|90(?:\.0+)?))$/,
    message: "Invalid latitude value",
  },
};

export const LongitudeValidator = {
  required: true,
  pattern: {
    value: /^([-+]?(?:\d{1,2}|1[0-7]\d)(?:\.\d+)?|180(?:\.0+)?)$/,
    message: "Invalid longitude value",
  },
};

export const EmailOptional = {
  required: false,
  pattern: {  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i },
};
export const VehiclePlateNumber = {
  required: true,
  pattern: { value: /^\d{1,6}$/i },
}

export const DeclarationCode ={
  required: true,
  // pattern: { value: /^\d{13}/i },
  pattern: { value: /^\d{1,20}$/ },
  maxLength: 20,
}

export const AnyValidString = {
  required: true,
  maxLength: 80,
};

export const SelectAnyValue = {
  required: true,
};

export const ZipCode = {
  required: true,
  minLength: 4,
  maxLength: 6,
};

export const Required = {
  required: true,
};

export const VehicleModelYear = {
  required: true,
  validate: (value: string | number) => {
    const currentYear = new Date().getFullYear();
    if (!/^(19|20)\d{2}$/.test(value.toString())) {
      return "Invalid vehicle model year. Please enter a valid year.";
    }
    if (parseInt(value.toString(), 10) > currentYear) {
      return `Invalid vehicle model year. Year cannot be greater than ${currentYear}.`;
    }
    return true;
  },
};

export const capitalizeWords = (str: string) => {
  return str
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};